import React, { useEffect, useState, useCallback } from 'react';
import { FaRegCopy, FaEdit } from 'react-icons/fa';
import { Table, Thead, Tbody, Tfoot, Tr, Th, Td } from '@chakra-ui/react';

import api from '../../services/api';
import { useAuth } from '../../hooks/auth';
import { useToast } from '../../hooks/toast';
import Loading from '../../components/Loading';
import Sidebar from '../../components/Sidebar';
import ModalCadCampanha from '../../components/Modal/ModalCadCampanha';
import { formatPrice } from '../../utils/format';

import {
  Container,
  Content,
  HeaderContent,
} from './styles';

interface CampanhaDATA {
  cam_json: string;
  canal_mkt: string;
  datlan: string;
  fim: string;
  icone: string;
  id: string;
  influencer: string;
  inicio: string;
  qdt_order: number;
  qtd_clik: number;
  url_link: string;
  usuario: string;
  vlr_order: number;
  valor: number;
}
interface CampanhaEditarDATA {
  date_f: string;
  date_i: string;
  descricao: string;
  id: string;
  id_canal: string;
  id_influencer: number;
  url: string;
  valor: number;
}

const Promocao: React.FC = () => {
  const { company, permissions } = useAuth();
  const { addToast } = useToast();

  const [loading, setLoading] = useState(true);
  const [campanhas, setCampanhas] = useState<CampanhaDATA[]>([]);
  const [modalCadCampanhaVisible, setModalCadCampanhaVisible] = useState(false);

  const [campanhaEditar, setCampanhaEditar] = useState(
    {} as CampanhaEditarDATA,
  );
  const [canal, setCanal] = useState('');

  const handleGetCampanhas = useCallback(async () => {
    await api.get('portal/campanha/index').then(response => {
      setCampanhas(response.data);
    });
  }, []);

  useEffect(() => {
    handleGetCampanhas();
    setLoading(false);
  }, [company, handleGetCampanhas]); // company para atualizar quando trocar a empresa

  const handleCopy = useCallback(
    (url: string) => {
      const inputText = document.createElement('input');
      inputText.value = url;
      document.body.appendChild(inputText);
      inputText.select();
      document.execCommand('copy');
      document.body.removeChild(inputText);

      addToast({
        type: 'info',
        title: 'Código copiado',
        description: 'Código para pagamento pix copiado.',
      });
    },
    [addToast],
  );

  return (
    <>
      <Container>
        {loading ? (
          <Loading />
        ) : (
          <>
            <Sidebar />

            <Content>
              <HeaderContent>
								{permissions.incluir && (
									<button
                  className="btn-add-class"
                  onClick={() => {
                    setCanal('');
                    setCampanhaEditar({} as CampanhaEditarDATA);
                    setModalCadCampanhaVisible(true);
                  }}
                >
                  + Add Campanha
                </button>
								)}
              </HeaderContent>

              {campanhas.length === 0 ? (
                <div className="campanhas-vazio">
                  <h1>Nenhuma campanha</h1>
                </div>
              ) : (
                <Table variant="simple" className="table">
                  <Thead className="head">
                    <Tr>
                      <Th>Canal</Th>
                      <Th>Inicio</Th>
                      <Th>Fim</Th>
                      <Th>Influencer</Th>
                      <Th isNumeric>Qtd clicks</Th>
                      <Th isNumeric>Qtd pedidos</Th>
                      <Th isNumeric>Vlr Vendas</Th>
                      <Th isNumeric>Vlr Custo</Th>
                      <Th isNumeric>Url</Th>
											{permissions.alterar && <Th isNumeric>Editar</Th>}
                    </Tr>
                  </Thead>

                  <Tbody className="body">
                    {campanhas.map((campanha, indice) => (
                      <Tr key={indice}>
                        {campanha.icone ? (
                          <Td>
                            <img
                              src={campanha.icone}
                              alt={campanha.canal_mkt}
                            />
                          </Td>
                        ) : (
                          <Td>{campanha.canal_mkt}</Td>
                        )}
                        <Td>{campanha.inicio}</Td>
                        <Td>{campanha.fim}</Td>
                        <Td>{campanha.influencer}</Td>
                        <Td isNumeric>{campanha.qtd_clik}</Td>
                        <Td isNumeric>{campanha.qdt_order}</Td>
                        <Td isNumeric>{formatPrice(campanha.vlr_order)}</Td>
                        <Td isNumeric>{formatPrice(campanha.valor)}</Td>
                        <Td isNumeric>
                          <button
                            className="btn"
                            onClick={() => handleCopy(campanha.url_link)}
                          >
                            Copiar&nbsp;
                            <FaRegCopy />
                          </button>
                        </Td>
												{permissions.alterar && (
													<Td isNumeric>
														<button
															className="btn"
															onClick={() => {
																setCanal(JSON.parse(campanha.cam_json).id_canal);
																setCampanhaEditar(JSON.parse(campanha.cam_json));
																setModalCadCampanhaVisible(true);
															}}
														>
															Editar&nbsp;
															<FaEdit />
														</button>
													</Td>
												)}
                      </Tr>
                    ))}
                  </Tbody>
                  <Tfoot className="foot">
                    <Tr className="tr">
                      <Th>Canal</Th>
                      <Th>Inicio</Th>
                      <Th>Fim</Th>
                      <Th>Influencer</Th>
                      <Th isNumeric>Qtd clicks</Th>
                      <Th isNumeric>Qtd pedidos</Th>
                      <Th isNumeric>Vlr Vendas</Th>
                      <Th isNumeric>Vlr Custo</Th>
                      <Th isNumeric>Url</Th>
											{permissions.alterar && <Th isNumeric>Editar</Th>}
                    </Tr>
                  </Tfoot>
                </Table>
              )}
            </Content>
          </>
        )}
      </Container>

      {modalCadCampanhaVisible && (
        <ModalCadCampanha
          campanha={campanhaEditar}
          canal={canal}
          handleGetCampanhas={handleGetCampanhas}
          onClose={() => setModalCadCampanhaVisible(false)}
        />
      )}
    </>
  );
};

export default Promocao;
